// PDP pre order statement

(function () {
  function insertPreorderNote(root) {
    root = root || document;

    const dataEl = document.getElementById('preorder-note-data');
    if (!dataEl) return;

    let noteText;
    try {
      noteText = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }
    if (!noteText || !noteText.trim()) return;
    noteText = noteText.trim();
    // Your SVG icon markup — replace with your actual icon
    const svgIcon = `<svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M8.25 5.25H8.256M8.25 11.25V7.5M15.75 8.25C15.75 12.3922 12.3922 15.75 8.25 15.75C4.10775 15.75 0.75 12.3922 0.75 8.25C0.75 4.10775 4.10775 0.75 8.25 0.75C12.3922 0.75 15.75 4.10775 15.75 8.25Z" stroke="#EC5C50" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`;

    root.querySelectorAll('.m-product-option').forEach(function (optionEl) {
      const variantBtn = optionEl.querySelector('variant-button[data-option-name="Availability Status"]');
      if (!variantBtn) return;

      const errorDiv = optionEl.querySelector('.m-product-option-error');
      if (!errorDiv) return;
      if (optionEl.querySelector('.m-product-option--note')) return;

      const noteEl = document.createElement('p');
      noteEl.className = 'm-product-option--note';
      noteEl.style.display = 'flex';
      noteEl.style.alignItems = 'center';
      noteEl.style.justifyContent = 'center';
      noteEl.style.gap = '4px';
      noteEl.innerHTML = svgIcon + '<span>' + noteText + '</span>';
      errorDiv.parentNode.insertBefore(noteEl, errorDiv);
    });
  }

  insertPreorderNote();

  document.addEventListener('shopify:section:load', function (e) {
    insertPreorderNote(e.target);
  });

})();


// Product page buy 2 for offer calculation
(function() {
  // Wait until DOM is loaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize);
  } else {
    initialize();
  }

  function initialize() {
    // Only run on product pages with the offer text element
    const offerElement = document.querySelector('.offer-text');
    if (!offerElement) return; // Exit immediately if offer-text doesn't exist
    
    let lastPrice = 0;
    let updateTimeout = null;
    
    // Function to get the current variant price
    function getCurrentPrice() {
      const priceElement = document.querySelector('.m-price-item--regular');
      
      if (!priceElement) {
        return 0;
      }
      
      // Extract just the number from the price text (removing currency symbols and commas)
      const priceText = priceElement.textContent.trim();
      return parseFloat(priceText.replace(/[^\d.]/g, ''));
    }

    // function to get offer price
    function getOfferPrice() {
      const priceElement = document.querySelector(".offer_discount");
      if (!priceElement) {
        return 0;
      }
      // Extract just the number from the price text (removing currency symbols and commas)
      const priceText = priceElement.textContent.trim();
      return parseFloat(priceText.replace(/[^\d.]/g, ''));
    }
    
    // Calculate and update the Buy 2 offer price
    function updateOfferPrice() {
      // Clear any pending updates
      if (updateTimeout) {
        clearTimeout(updateTimeout);
        updateTimeout = null;
      }
      
      const currentPrice = getCurrentPrice();
      const offerPrice = getOfferPrice();
      
      
      // Only update if price has changed
      if (currentPrice === lastPrice) return;
      lastPrice = currentPrice;
      
      // Fixed discount value
      const discount = offerPrice;
      
      // Calculate the buy 2 price
      const buyTwoPrice = (2 * currentPrice) - discount;
      const roundedPrice = Math.round(buyTwoPrice / 100) * 100;
      
      // Format with comma separator for thousands
      const formattedPrice = '₹' + roundedPrice.toLocaleString('en-IN');
      
      // Update the DOM only once
      const offerPriceElement = document.getElementById('dynamic-offer-price');
      if (offerPriceElement) {
        if(!isNaN(roundedPrice)) {
          offerPriceElement.textContent = formattedPrice;
        }
        // offerPriceElement.textContent = formattedPrice;
      }
    }
    
    // Debounced update function to avoid excessive calculations
    function debouncedUpdate() {
      if (updateTimeout) {
        clearTimeout(updateTimeout);
      }
      updateTimeout = setTimeout(updateOfferPrice, 50);
    }
    
    // Run once on page load
    updateOfferPrice();
    
    // Use a single MutationObserver for price changes
    const priceObserver = new MutationObserver(debouncedUpdate);
    
    // Find the price element and its container
    const priceElement = document.querySelector('.m-price-item--regular');
    if (priceElement) {
      // Watch just the parent to catch price updates
      const priceContainer = priceElement.parentElement;
      if (priceContainer) {
        priceObserver.observe(priceContainer, {
          childList: true,
          subtree: true,
          characterData: true
        });
      }
    }
    
    // Watch for variant change events (Shopify standard)
    document.addEventListener('variant:change', debouncedUpdate);
    
    // Reduced polling interval
    const intervalId = setInterval(function() {
      // Stop polling after 30 seconds if price is stable
      if (document.visibilityState === 'hidden' || window.pollCount > 30) {
        clearInterval(intervalId);
      } else {
        debouncedUpdate();
        window.pollCount = (window.pollCount || 0) + 1;
      }
    }, 1000);
    
    // Add efficient event delegation for variant selectors
    document.addEventListener('change', function(event) {
      if (event.target.matches('select[name="id"], input[name="id"], .single-option-selector')) {
        debouncedUpdate();
      }
    });
    
    // Handle click events on variant selectors with event delegation
    document.addEventListener('click', function(event) {
      if (event.target.matches('.swatch-element label, [data-index="option1"], [data-index="option2"], [data-index="option3"]')) {
        setTimeout(debouncedUpdate, 100);
      }
    });
  }
})();




// js to change /collection/him.running scenarios
// Dynamic Collection Header Image Changer
(function() {
    // Function to wait for element to exist
    function waitForElement(selector, timeout = 5000) {
        return new Promise((resolve) => {
            const element = document.querySelector(selector);
            if (element) {
                resolve(element);
                return;
            }

            const observer = new MutationObserver(() => {
                const element = document.querySelector(selector);
                if (element) {
                    observer.disconnect();
                    resolve(element);
                }
            });

            observer.observe(document.body, {
                childList: true,
                subtree: true
            });

            // Timeout fallback
            setTimeout(() => {
                observer.disconnect();
                resolve(null);
            }, timeout);
        });
    }

    // Function to change collection header image
    async function changeCollectionHeaderImage() {
        // Get current URL path
        const currentPath = window.location.pathname;
        
        // Check if URL matches pattern /collections/[parent]/[subcategory]
        const collectionMatch = currentPath.match(/^\/collections\/([^\/]+)\/([^\/]+)$/);
        
        if (collectionMatch) {
            const parentCollection = collectionMatch[1]; // Extract parent (him, her, etc.)
            const subcategory = collectionMatch[2]; // Extract subcategory (running, outdoor, etc.)
            
            // Wait for the header background image element to exist
            const headerImg = await waitForElement('.m-collection-page-header__background img');
            
            if (headerImg) {
                // Get all existing width parameters from the current src
                const currentSrc = headerImg.src;
                const widthParams = currentSrc.match(/[?&](width=\d+)/g) || [];
                const otherParams = currentSrc.match(/[?&](v=\d+)/g) || [];
                
                // Build new image URL with parent collection
                let newImageUrl = `/cdn/shop/collections/${parentCollection}-${subcategory}-collection.png`;
                
                // Add parameters if they exist
                if (widthParams.length > 0 || otherParams.length > 0) {
                    newImageUrl += '?';
                    const allParams = [...widthParams, ...otherParams];
                    newImageUrl += allParams.join('&').replace(/[?&]/g, '').split('').join('&').replace(/^&/, '');
                }
                
                // Create a new image to test if it exists
                const testImg = new Image();
                
                testImg.onload = function() {
                    // Image exists, update all srcset and src attributes
                    headerImg.src = newImageUrl;
                    
                    // Update srcset if it exists
                    if (headerImg.srcset) {
                        const srcsetParts = headerImg.srcset.split(',');
                        const newSrcset = srcsetParts.map(part => {
                            const [url, descriptor] = part.trim().split(' ');
                            const widthMatch = descriptor ? descriptor.match(/(\d+)w/) : null;
                            if (widthMatch) {
                                const width = widthMatch[1];
                                return `/cdn/shop/collections/${parentCollection}-${subcategory}-collection.png?width=${width} ${descriptor}`;
                            }
                            return part;
                        }).join(', ');
                        
                        headerImg.srcset = newSrcset;
                    }
                    
                    console.log(`Collection header image updated for: ${parentCollection}/${subcategory}`);
                };
                
                testImg.onerror = function() {
                    console.log(`Image not found: ${newImageUrl}`);
                    // Keep original image if custom one doesn't exist
                };
                
                // Test if the image exists
                testImg.src = newImageUrl;
            }
        }
    }
    
    // Function to change collection title and description
    async function changeCollectionTitleAndDescription() {
        const currentPath = window.location.pathname;
        const collectionMatch = currentPath.match(/^\/collections\/([^\/]+)\/([^\/]+)$/);
        
        if (collectionMatch) {
            const parentCollection = collectionMatch[1]; // Extract parent (him, her, etc.)
            const subcategory = collectionMatch[2]; // Extract subcategory
            
            // Wait for title element and update it
            const titleElement = await waitForElement('.m-collection-page-header__title');
            if (titleElement) {
                const formattedSubcategory = subcategory.charAt(0).toUpperCase() + subcategory.slice(1);
                titleElement.textContent = `${formattedSubcategory} Collection`;
            }
            
            // Wait for description element and update it
            const descriptionElement = await waitForElement('.m-collection-page-header__description p');
            if (descriptionElement) {
                let descriptionText = '';
                
                if (parentCollection.toLowerCase() === 'him') {
                    descriptionText = "MEN'S";
                } else if (parentCollection.toLowerCase() === 'her') {
                    descriptionText = "WOMEN'S";
                }
                
                if (descriptionText) {
                    descriptionElement.textContent = descriptionText;
                }
            }
        }
    }
    
    // Run when DOM is ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function() {
            changeCollectionHeaderImage();
            changeCollectionTitle();
        });
    } else {
        changeCollectionHeaderImage();
        changeCollectionTitleAndDescription();
    }
    
    // Also run on URL changes (for single page app behavior)
    let lastUrl = location.href;
    new MutationObserver(() => {
        const url = location.href;
        if (url !== lastUrl) {
            lastUrl = url;
            Promise.all([
                changeCollectionHeaderImage(),
                changeCollectionTitleAndDescription()
            ]);
        }
    }).observe(document, { subtree: true, childList: true });
    
})();


// Sticy js for product page sticky bar for the link to go to the product info section
// Function to update button text based on preorder status
function updateButtonText() {
  const button = document.querySelector('.sticky-action-btn');
  if (!button) return;
  
  const hasPreorderClass = document.querySelector('.m-sticky-addtocart--rightblock .m-product-form form .essential-preorder-container-active');
  
  if (hasPreorderClass) {
    button.textContent = 'Pre-Order';
  } else {
    button.textContent = 'Add to cart';
  }
}

// Initialize button text on page load
document.addEventListener('DOMContentLoaded', updateButtonText);

// Create MutationObserver to watch for DOM changes
const productButtonTextObserver = new MutationObserver(function(mutations) {
  updateButtonText();
});

// Start observing the document with the configured parameters
document.addEventListener('DOMContentLoaded', function() {
  const targetNode = document.querySelector('.m-sticky-addtocart--rightblock .m-product-form form');
  if (targetNode) {
    productButtonTextObserver.observe(targetNode, { 
      attributes: true, 
      childList: true, 
      subtree: true 
    });
  }
});




// Preorder button js for sticky bar in mobile on product pages
document.addEventListener('DOMContentLoaded', function() {
  try {
    // Function to copy preorder button to sticky bar if it exists
    function updateStickyPreorderButton() {
      try {
        // Get the main preorder container
        const mainPreorderContainer = document.querySelector('.m-product-form--main .essential-preorder-container-active');
        
        // Get the sticky form add to cart button
        const stickyAddToCartBtn = document.querySelector('.m-sticky-addtocart .sticky-atc-form .m-add-to-cart');
        
        // If sticky add to cart button doesn't exist, exit gracefully
        if (!stickyAddToCartBtn) {
          return;
        }
        
        // Get any existing preorder in sticky bar
        const existingStickyPreorder = document.querySelector('.m-sticky-addtocart .sticky-atc-form .essential-preorder-container-active');
        
        // If main preorder exists 
        if (mainPreorderContainer) {
          // If there's no preorder in sticky bar or it's different from the main one
          if (!existingStickyPreorder || existingStickyPreorder.outerHTML !== mainPreorderContainer.outerHTML) {
            // Remove existing one if it's there
            if (existingStickyPreorder) {
              existingStickyPreorder.remove();
            }
            
            // Copy the preorder button to the sticky bar
            stickyAddToCartBtn.insertAdjacentHTML('afterend', mainPreorderContainer.outerHTML);
          }
        } 
        // If main preorder doesn't exist but there's one in the sticky bar
        else if (!mainPreorderContainer && existingStickyPreorder) {
          // Remove it from sticky bar
          existingStickyPreorder.remove();
        }
      } catch (e) {
        // Silent error handling
      }
    }
    
    // Function to initialize observers after ensuring DOM elements exist
    function initObservers() {
      // Get the main product form where preorder button may appear
      const mainProductForm = document.querySelector('.m-product-form--main');
      
      if (!mainProductForm) {
        // If main form not found, retry later
        setTimeout(initObservers, 500);
        return;
      }
      
      // Set up a targeted MutationObserver to watch only the main product form
      try {
        const observer = new MutationObserver(function(mutations) {
          // Check if any of the mutations involve the preorder container
          const preorderAffected = mutations.some(function(mutation) {
            // Check added nodes
            for (let i = 0; i < mutation.addedNodes.length; i++) {
              const node = mutation.addedNodes[i];
              if (node.nodeType === 1) { // Element node
                if (node.classList && node.classList.contains('essential-preorder-container-active')) {
                  return true;
                }
                if (node.querySelector && node.querySelector('.essential-preorder-container-active')) {
                  return true;
                }
              }
            }
            
            // Check removed nodes
            for (let i = 0; i < mutation.removedNodes.length; i++) {
              const node = mutation.removedNodes[i];
              if (node.nodeType === 1) { // Element node
                if (node.classList && node.classList.contains('essential-preorder-container-active')) {
                  return true;
                }
                if (node.querySelector && node.querySelector('.essential-preorder-container-active')) {
                  return true;
                }
              }
            }
            
            // Check if target itself is or contains preorder
            if (mutation.target.classList && mutation.target.classList.contains('essential-preorder-container-active')) {
              return true;
            }
            if (mutation.target.querySelector && mutation.target.querySelector('.essential-preorder-container-active')) {
              return true;
            }
            
            return false;
          });
          
          // Only update if preorder-related changes were detected
          if (preorderAffected) {
            updateStickyPreorderButton();
          }
        });
        
        // Observe only the main product form with minimal necessary options
        observer.observe(mainProductForm, {
          childList: true,
          subtree: true,
          attributes: false,
          characterData: false
        });
        
        // Also listen for variant changes for added reliability
        document.addEventListener('variant:change', updateStickyPreorderButton);
        
        // Listen for option changes
        const variantSelectors = document.querySelectorAll('.single-option-selector, select[name^="options"]');
        for (let i = 0; i < variantSelectors.length; i++) {
          variantSelectors[i].addEventListener('change', updateStickyPreorderButton);
        }
        
        // Run once immediately
        updateStickyPreorderButton();
        
        // Run again after a short delay to ensure we catch late-loading elements
        setTimeout(updateStickyPreorderButton, 500);
      } catch (e) {
        // Fallback to interval if observer fails
        setInterval(updateStickyPreorderButton, 1000);
      }
    }
    
    // Start the initialization process
    initObservers();
    
  } catch (e) {
    // Silent error handling
  }
});







//Judgeme review js
(function() {
  // Track state
  let initialized = false;
  let attemptCount = 0;
  let maxAttempts = 100; // Keep trying for much longer
  let permanentInterval = null;
  
  // Add styles immediately
  addStyles();
  
  // Start the permanent watcher immediately
  startPermanentWatcher();
  
  // Also try on various page events
  document.addEventListener('DOMContentLoaded', checkAndFix);
  window.addEventListener('load', checkAndFix);
  
  // Try immediately as well
  checkAndFix();
  
  function addStyles() {
    const style = document.createElement('style');
    style.textContent = `
      /* Hide elements until ready */
      .jdgm-widget-actions-wrapper, 
      .jdgm-form-wrapper, 
      .jdgm-rev-widg__title,
      .jdgm-rev-widg__summary-average,
       {
        opacity: 0;
        transition: opacity 300ms ease-in;
      }
      
      .jdgm-elements-ready {
        opacity: 1;
      }
      
      /* Progress bar styles */
      .circular-progress-container {
        position: relative;
        width: 68px;
        height: 68px;
        margin: 10px auto;
        opacity: 0;
        transition: opacity 300ms ease-in;
      }
      
      .circular-progress-ready {
        opacity: 1;
      }
      
      .circular-progress-text {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 24px;
        font-weight: bold;
      }
      
      .circular-progress-wrapper {
        display: flex;
        flex-direction: column;
        align-items: center;
      }
    `;
    document.head.appendChild(style);
  }
  
  function startPermanentWatcher() {
    // This interval will keep running until the page is unloaded
    permanentInterval = setInterval(function() {
      if (initialized) {
        // If we've successfully initialized, reduce check frequency but don't stop
        // This handles cases where the widget might be reloaded by the app
        clearInterval(permanentInterval);
        permanentInterval = setInterval(checkAndFix, 2000);
        return;
      }
      
      attemptCount++;
      checkAndFix();
      
      // After many attempts, try the nuclear option
      if (attemptCount > maxAttempts) {
        forceFixLayout();
      }
    }, 200); // Check very frequently
  }
  
  // Function to check if there are no reviews
  function hasNoReviews() {
    // Check for the no reviews message
    const noReviewsMsg = document.querySelector('.jdgm-no-reviews');
    if (noReviewsMsg) return true;
    
    // Check if there are any review elements
    const reviews = document.querySelectorAll('.jdgm-rev');
    return reviews.length === 0;
  }
  
  function checkAndFix() {
    try {
      // First check if the widget exists
      const widget = document.querySelector('.jdgm-rev-widg');
      if (!widget) return false;
      
      // Check if there are no reviews
      if (hasNoReviews()) {
        return handleNoReviews(widget);
      }
      
      // Check for all the elements we need
      const elements = {
        actionsWrapper: document.querySelector('.jdgm-widget-actions-wrapper'),
        formWrapper: document.querySelector('.jdgm-form-wrapper'),
        titleElement: document.querySelector('.jdgm-rev-widg__title'),
        targetParent: document.querySelector('.jdgm-rev-widg__body'),
        summaryAverage: document.querySelector('.jdgm-rev-widg__summary-average'),
        summaryStars: document.querySelector('.jdgm-rev-widg__summary-stars'),
        summaryText: document.querySelector('.jdgm-rev-widg__summary-text')
      };
      
      // If any required elements are missing, we can't proceed
      if (!elements.actionsWrapper || !elements.formWrapper || 
          !elements.titleElement || !elements.targetParent) {
        return false;
      }
      
      // Check if elements are already in the correct position
      const titleIsFirst = elements.targetParent.firstChild === elements.titleElement;
      const actionsInTarget = elements.targetParent.contains(elements.actionsWrapper);
      const formInTarget = elements.targetParent.contains(elements.formWrapper);
      
      if (titleIsFirst && actionsInTarget && formInTarget) {
        // Elements are already in the right place, just make them visible
        makeElementsVisible(elements);
        createCircularProgressBars();
        initialized = true;
        return true;
      }
      
      // Move elements to the correct positions
      moveElements(elements);
      
      // Make elements visible
      makeElementsVisible(elements);
      
      // Create circular progress bars
      createCircularProgressBars();
      
      // Mark as initialized
      initialized = true;
      return true;
    } catch (error) {
      return false;
    }
  }
  
  // Function to handle the no-reviews case
  function handleNoReviews(widget) {
    try {
      // Find the elements we need in the no-reviews case
      const title = widget.querySelector('.jdgm-rev-widg__title');
      const actionsWrapper = widget.querySelector('.jdgm-widget-actions-wrapper');
      const formWrapper = widget.querySelector('.jdgm-form-wrapper');
      const noReviewsMsg = widget.querySelector('.jdgm-no-reviews');
      
      // Find or create the body element
      let body = widget.querySelector('.jdgm-rev-widg__body');
      if (!body) {
        body = document.createElement('div');
        body.className = 'jdgm-rev-widg__body';
        widget.appendChild(body);
      }
      
      // Make sure the body is visible
      if (window.getComputedStyle(body).display === 'none') {
        body.style.display = 'block';
      }
      
      // Only proceed if we have the minimum required elements
      if (title && actionsWrapper) {
        // Only move elements if they're not already in the right place
        const titleInBody = body.contains(title);
        const actionsInBody = body.contains(actionsWrapper);
        const formInBody = formWrapper && body.contains(formWrapper);
        const noReviewsInBody = noReviewsMsg && body.contains(noReviewsMsg);
        
        if (!titleInBody || !actionsInBody || (formWrapper && !formInBody) || (noReviewsMsg && !noReviewsInBody)) {
          // Remove elements from their current parents
          if (title.parentNode) title.parentNode.removeChild(title);
          if (actionsWrapper.parentNode) actionsWrapper.parentNode.removeChild(actionsWrapper);
          if (formWrapper && formWrapper.parentNode) formWrapper.parentNode.removeChild(formWrapper);
          if (noReviewsMsg && noReviewsMsg.parentNode) noReviewsMsg.parentNode.removeChild(noReviewsMsg);
          
          // Add them to the body in the correct order
          body.appendChild(title);
          if (noReviewsMsg) body.appendChild(noReviewsMsg);
          body.appendChild(actionsWrapper);
          if (formWrapper) body.appendChild(formWrapper);
        }
        
        // Make elements visible using the original approach
        if (title) title.classList.add('jdgm-elements-ready');
        if (actionsWrapper) actionsWrapper.classList.add('jdgm-elements-ready');
        if (formWrapper) formWrapper.classList.add('jdgm-elements-ready');
        
        initialized = true;
        return true;
      }
    } catch (error) {
      // Silent error handling
    }
    
    return false;
  }
  
  function moveElements(elements) {
    // Use direct DOM manipulation for maximum reliability
    
    // Move title to be the first child of the target parent
    if (elements.titleElement.parentNode) {
      elements.titleElement.parentNode.removeChild(elements.titleElement);
    }
    
    if (elements.targetParent.firstChild) {
      elements.targetParent.insertBefore(elements.titleElement, elements.targetParent.firstChild);
    } else {
      elements.targetParent.appendChild(elements.titleElement);
    }
    
    // Move actions wrapper to the end of the target parent
    if (elements.actionsWrapper.parentNode) {
      elements.actionsWrapper.parentNode.removeChild(elements.actionsWrapper);
    }
    elements.targetParent.appendChild(elements.actionsWrapper);
    
    // Move form wrapper to the end of the target parent
    if (elements.formWrapper.parentNode) {
      elements.formWrapper.parentNode.removeChild(elements.formWrapper);
    }
    elements.targetParent.appendChild(elements.formWrapper);
    
    // Handle summary elements if they exist
    if (elements.summaryAverage && elements.summaryStars) {
      if (elements.summaryStars.firstChild !== elements.summaryAverage) {
        if (elements.summaryAverage.parentNode) {
          elements.summaryAverage.parentNode.removeChild(elements.summaryAverage);
        }
        
        if (elements.summaryStars.firstChild) {
          elements.summaryStars.insertBefore(elements.summaryAverage, elements.summaryStars.firstChild);
        } else {
          elements.summaryStars.appendChild(elements.summaryAverage);
        }
      }
      
      if (elements.summaryText && elements.summaryText.parentNode) {
        elements.summaryText.parentNode.removeChild(elements.summaryText);
        elements.summaryAverage.parentNode.insertBefore(elements.summaryText, elements.summaryAverage.nextSibling);
      }
    }
  }
  
  function makeElementsVisible(elements) {
    // Make elements visible
    [elements.actionsWrapper, elements.formWrapper, elements.titleElement, 
     elements.summaryAverage, elements.summaryText].forEach(el => {
      if (el) el.classList.add('jdgm-elements-ready');
    });
  }
  
  function createCircularProgressBars() {
    try {
      // Find all elements with the class jdgm-cf-bars-wrapper
      const barWrappers = document.querySelectorAll('.jdgm-cf-bars-wrapper');
      
      barWrappers.forEach(wrapper => {
        // Skip if already processed
        if (wrapper.dataset.processedCircle === 'true') return;
        
        // Get the data-value attribute (e.g., "3/5", "1/5")
        const dataValue = wrapper.getAttribute('data-value');
        
        if (!dataValue || !dataValue.includes('/')) {
          return;
        }
        
        // Find the target container
        const targetContainer = wrapper.closest('.jdgm-rev__cf-ans');
        if (!targetContainer) {
          return;
        }
        
        // Find the title element and remove colon if present
        const titleElement = targetContainer.querySelector('.jdgm-rev__cf-ans__title');
        if (titleElement && titleElement.textContent) {
          titleElement.textContent = titleElement.textContent.replace(/:\s*$/, '');
        }
        
        // Parse the fraction
        const [numerator, denominator] = dataValue.split('/').map(Number);
        
        // Calculate the percentage
        const percentage = (numerator / denominator) * 100;
        
        // Determine the color based on the numerator value
        let progressColor;
        if (numerator <= 2) {
          progressColor = '#FFA07A'; // Soft orange
        } else if (numerator <= 4) {
          progressColor = '#C1D83F'; // Lime green
        } else {
          progressColor = '#81A465'; // Sage green
        }
        
        // Create the SVG element using a template string for better readability
        const svgHTML = `
          <div class="circular-progress-container">
            <svg width="68" height="68" viewBox="0 0 68 68">
              <circle cx="34" cy="34" r="30" fill="none" stroke="#e6e6e6" stroke-width="4"></circle>
              <circle cx="34" cy="34" r="30" fill="none" 
                      stroke="${progressColor}" 
                      stroke-width="4" 
                      stroke-dasharray="${2 * Math.PI * 30}" 
                      stroke-dashoffset="${2 * Math.PI * 30 * (1 - percentage / 100)}" 
                      transform="rotate(-90 34 34)"></circle>
            </svg>
            <div class="circular-progress-text">${numerator}</div>
          </div>
        `;
        
        // Create wrapper and add SVG
        const completeWrapper = document.createElement('div');
        completeWrapper.className = 'circular-progress-wrapper';
        completeWrapper.innerHTML = svgHTML;
        
        // Insert at the beginning of the target container
        if (targetContainer.firstChild) {
          targetContainer.insertBefore(completeWrapper, targetContainer.firstChild);
        } else {
          targetContainer.appendChild(completeWrapper);
        }
        
        // Mark as processed
        wrapper.dataset.processedCircle = 'true';
        
        // Make progress bar visible
        setTimeout(() => {
          completeWrapper.querySelector('.circular-progress-container').classList.add('circular-progress-ready');
        }, 10);
      });
    } catch (error) {
      // Silent error handling
    }
  }
  
  function forceFixLayout() {
    try {
      // This is a last resort function that will be called if all else fails
      
      // Check if there are no reviews
      if (hasNoReviews()) {
        const widget = document.querySelector('.jdgm-rev-widg');
        if (widget) {
          return handleNoReviews(widget);
        }
        return;
      }
      
      // Find all the elements we need
      const widget = document.querySelector('.jdgm-rev-widg');
      if (!widget) return;
      
      // Find or create the body element
      let body = widget.querySelector('.jdgm-rev-widg__body');
      if (!body) {
        body = document.createElement('div');
        body.className = 'jdgm-rev-widg__body';
        widget.appendChild(body);
      }
      
      // Find all the elements we need to move
      const title = widget.querySelector('.jdgm-rev-widg__title');
      const actionsWrapper = widget.querySelector('.jdgm-widget-actions-wrapper');
      const formWrapper = widget.querySelector('.jdgm-form-wrapper');
      
      // If any of these elements don't exist, we can't proceed
      if (!title || !actionsWrapper || !formWrapper) return;
      
      // Force move elements to the correct positions
      if (title.parentNode) {
        title.parentNode.removeChild(title);
      }
      
      if (body.firstChild) {
        body.insertBefore(title, body.firstChild);
      } else {
        body.appendChild(title);
      }
      
      if (actionsWrapper.parentNode) {
        actionsWrapper.parentNode.removeChild(actionsWrapper);
      }
      body.appendChild(actionsWrapper);
      
      if (formWrapper.parentNode) {
        formWrapper.parentNode.removeChild(formWrapper);
      }
      body.appendChild(formWrapper);
      
      // Make elements visible
      [title, actionsWrapper, formWrapper].forEach(el => {
        if (el) el.classList.add('jdgm-elements-ready');
      });
      
      // Try to create circular progress bars
      createCircularProgressBars();
      
      // Mark as initialized
      initialized = true;
    } catch (error) {
      // Silent error handling
    }
  }
  
  // Create a MutationObserver to watch for changes to the DOM
  function setupMutationObserver() {
    // Create an observer instance
    const observer = new MutationObserver(function(mutations) {
      // If we're not initialized yet, don't do anything
      if (!initialized) return;
      
      // Check if any mutations affected our target elements
      let needsCheck = false;
      
      mutations.forEach(function(mutation) {
        // If the body element is hidden, we need to check
        if (mutation.type === 'attributes' && 
            mutation.attributeName === 'style' && 
            mutation.target.classList.contains('jdgm-rev-widg__body')) {
          const style = window.getComputedStyle(mutation.target);
          if (style.display === 'none') {
            needsCheck = true;
          }
        }
        
        // If nodes were added or removed from the widget
        if (mutation.type === 'childList' && 
            (mutation.target.classList.contains('jdgm-rev-widg') || 
             mutation.target.classList.contains('jdgm-rev-widg__body'))) {
          needsCheck = true;
        }
      });
      
      if (needsCheck) {
        // Run our fix function
        checkAndFix();
      }
    });
    
    // Start observing the document with the configured parameters
    observer.observe(document.body, {
      attributes: true,
      childList: true,
      subtree: true,
      attributeFilter: ['style', 'class']
    });
    
    return observer;
  }
  
  // Set up the mutation observer after a short delay
  setTimeout(setupMutationObserver, 500);
  
  // Try to hook into Judge.me's own script if possible
  try {
    // Check if Judge.me has a global object we can hook into
    if (window.jdgm) {
      // If Judge.me has already loaded, try to fix now
      checkAndFix();
      
      // Try to hook into Judge.me's initialization
      const originalInit = window.jdgm.init;
      if (typeof originalInit === 'function') {
        window.jdgm.init = function() {
          // Call the original init function
          const result = originalInit.apply(this, arguments);
          
          // Then try to fix our layout
          setTimeout(checkAndFix, 100);
          
          return result;
        };
      }
    }
  } catch (error) {
    // Silent error handling
  }
})();




//Size Chart
// document.addEventListener("DOMContentLoaded", () => {
//   // Add CSS styles directly in JavaScript
//   const styleElement = document.createElement("style")
//   styleElement.textContent = `
//     /* Lightbox overlay */
//     .lightbox-overlay {
//       position: fixed;
//       top: 0;
//       left: 0;
//       width: 100%;
//       height: 100%;
//       background-color: rgba(0, 0, 0, 0.85);
//       z-index: 9999;
//       display: flex;
//       justify-content: center;
//       align-items: center;
//     }
    
//     /* Lightbox container */
//     .lightbox-container {
//       position: relative;
//       width: 100%;
//       height: 100%;
//       display: flex;
//       flex-direction: column;
//       justify-content: center;
//       align-items: center;
//     }
    
//     /* Action buttons container */
//     .lightbox-actions {
//       position: absolute;
//       top: 20px;
//       right: 20px;
//       display: flex;
//       gap: 10px;
//       z-index: 10;
//     }
    
//     /* Action button style */
//     .lightbox-action-button {
//       width: 40px;
//       height: 40px;
//       border-radius: 50%;
//       background-color: rgba(0, 0, 0, 0.5);
//       border: none;
//       color: white;
//       display: flex;
//       align-items: center;
//       justify-content: center;
//       cursor: pointer;
//       transition: background-color 0.2s;
//     }
    
//     .lightbox-action-button:hover {
//       background-color: rgba(0, 0, 0, 0.7);
//     }
    
//     .lightbox-action-button svg {
//       width: 20px;
//       height: 20px;
//     }
    
//     /* Image style */
//     .lightbox-image {
//       max-width: 90%;
//       max-height: 80vh;
//       transition: transform 0.2s ease;
//       transform-origin: center center;
//     }
    
//     /* Caption style */
//     .lightbox-caption {
//       position: absolute;
//       bottom: 40px;
//       left: 0;
//       right: 0;
//       text-align: center;
//       color: white;
//       font-size: 18px;
//       font-weight: 600;
//       background-color: rgba(0, 0, 0, 0.3);
//       padding: 8px 16px;
//       margin: 0 auto;
//       max-width: fit-content;
//       border-radius: 4px;
//     }
//   `
//   document.head.appendChild(styleElement)

//   // Find or wait for the foxkit button
//   function findFoxkitButton() {
//     const foxkitButton = document.querySelector('.foxkit-sizechart-button');
    
//     if (foxkitButton) {
//       // Button found, set up click handler
//       setupFoxkitButton(foxkitButton);
//     } else {
//       // Button not found yet, try again in a moment
//       setTimeout(findFoxkitButton, 500);
//     }
//   }
  
//   // Start looking for the button
//   findFoxkitButton();
  
//   // Set up the foxkit button to use our size chart
//   function setupFoxkitButton(foxkitButton) {
//     // Remove any existing click handlers by cloning the button
//     const newButton = foxkitButton.cloneNode(true);
//     foxkitButton.parentNode.replaceChild(newButton, foxkitButton);
    
//     // Add our click handler
//     newButton.addEventListener('click', function(e) {
//       e.preventDefault();
//       e.stopPropagation();
      
//       // Display our enhanced size chart
//       showSizeChart();
      
//       return false;
//     });
//   }
  
//   // Function to show our enhanced size chart
//   function showSizeChart() {
//     // Get the size chart image from the existing popup
//     const sizeChartPopup = document.getElementById('size-chart-popup');
//     if (!sizeChartPopup) return;
    
//     const sizeChartImage = sizeChartPopup.querySelector('.size-chart-content img');
//     if (!sizeChartImage) return;
    
//     // Create lightbox
//     const lightbox = createLightbox();
    
//     // Clone the image for the lightbox
//     const lightboxImage = sizeChartImage.cloneNode(true);
//     lightboxImage.classList.add("lightbox-image");
//     lightboxImage.style.pointerEvents = 'auto'; // Enable pointer events for zoom/pan
    
//     // Add the image to the container
//     lightbox.container.appendChild(lightboxImage);
    
//     // Add caption
//     const caption = "Size Chart";
//     const captionElement = document.createElement("div");
//     captionElement.classList.add("lightbox-caption");
//     captionElement.textContent = caption;
//     lightbox.container.appendChild(captionElement);
    
//     // Wait for the image to load before setting up zoom/pan
//     if (lightboxImage.complete) {
//       setupInteractions(lightbox, lightboxImage);
//     } else {
//       lightboxImage.onload = function() {
//         setupInteractions(lightbox, lightboxImage);
//       };
//     }
//   }
  
//   // Create the lightbox elements
//   function createLightbox() {
//     // Create overlay
//     const lightboxOverlay = document.createElement("div");
//     lightboxOverlay.classList.add("lightbox-overlay");
    
//     // Create container
//     const lightboxContainer = document.createElement("div");
//     lightboxContainer.classList.add("lightbox-container");
    
//     // Create actions container
//     const lightboxActions = document.createElement("div");
//     lightboxActions.classList.add("lightbox-actions");
    
//     // Create zoom out button
//     const zoomOutButton = document.createElement("button");
//     zoomOutButton.classList.add("lightbox-action-button");
//     zoomOutButton.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//       <line x1="5" y1="12" x2="19" y2="12"></line>
//     </svg>`;
//     zoomOutButton.setAttribute("aria-label", "Zoom Out");
    
//     // Create reset button
//     const resetButton = document.createElement("button");
//     resetButton.classList.add("lightbox-action-button");
//     resetButton.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//       <path d="M3 2v6h6"></path>
//       <path d="M21 12A9 9 0 0 0 6 5.3L3 8"></path>
//       <path d="M21 22v-6h-6"></path>
//       <path d="M3 12a9 9 0 0 0 15 6.7l3-2.7"></path>
//     </svg>`;
//     resetButton.setAttribute("aria-label", "Reset Zoom");
    
//     // Create zoom in button
//     const zoomInButton = document.createElement("button");
//     zoomInButton.classList.add("lightbox-action-button");
//     zoomInButton.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//       <line x1="12" y1="5" x2="12" y2="19"></line>
//       <line x1="5" y1="12" x2="19" y2="12"></line>
//     </svg>`;
//     zoomInButton.setAttribute("aria-label", "Zoom In");
    
//     // Create close button
//     const closeButton = document.createElement("button");
//     closeButton.classList.add("lightbox-action-button");
//     closeButton.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//       <line x1="18" y1="6" x2="6" y2="18"></line>
//       <line x1="6" y1="6" x2="18" y2="18"></line>
//     </svg>`;
//     closeButton.setAttribute("aria-label", "Close");
    
//     // Add buttons to actions container
//     lightboxActions.appendChild(zoomOutButton);
//     lightboxActions.appendChild(resetButton);
//     lightboxActions.appendChild(zoomInButton);
//     lightboxActions.appendChild(closeButton);
    
//     // Add elements to DOM
//     lightboxContainer.appendChild(lightboxActions);
//     lightboxOverlay.appendChild(lightboxContainer);
//     document.body.appendChild(lightboxOverlay);
    
//     return {
//       overlay: lightboxOverlay,
//       container: lightboxContainer,
//       actions: lightboxActions,
//       zoomInButton,
//       zoomOutButton,
//       resetButton,
//       closeButton,
//     };
//   }
  
//   // Set up zoom and pan interactions
//   function setupInteractions(lightbox, lightboxImage) {
//     // Prevent body scrolling
//     document.body.style.overflow = "hidden";
    
//     // Track zoom level and position
//     let currentZoom = 1;
//     let currentX = 0;
//     const zoomStep = 0.1;
//     const maxZoom = 1.4; // Maximum zoom of 140%
//     const minZoom = 1;
    
//     // Update transform function
//     function updateTransform() {
//       lightboxImage.style.transform = `translateX(${currentX}px) scale(${currentZoom})`;
//     }
    
//     // Reset position and zoom
//     function resetView() {
//       currentZoom = 1;
//       currentX = 0;
//       updateTransform();
//     }
    
//     // Zoom in function
//     lightbox.zoomInButton.addEventListener("click", (e) => {
//       e.preventDefault();
//       e.stopPropagation();
      
//       if (currentZoom < maxZoom) {
//         currentZoom = Math.min(currentZoom + zoomStep, maxZoom);
//         updateTransform();
//       }
//     });
    
//     // Zoom out function
//     lightbox.zoomOutButton.addEventListener("click", (e) => {
//       e.preventDefault();
//       e.stopPropagation();
      
//       if (currentZoom > minZoom) {
//         currentZoom = Math.max(currentZoom - zoomStep, minZoom);
        
//         // Reset position if we're back to minZoom
//         if (currentZoom === minZoom) {
//           currentX = 0;
//         }
        
//         updateTransform();
//       }
//     });
    
//     // Reset zoom function
//     lightbox.resetButton.addEventListener("click", (e) => {
//       e.preventDefault();
//       e.stopPropagation();
//       resetView();
//     });
    
//     // Close function
//     function closeLightbox() {
//       document.body.style.overflow = "";
//       lightbox.overlay.remove();
//     }
    
//     // Close on button click
//     lightbox.closeButton.addEventListener("click", (e) => {
//       e.preventDefault();
//       e.stopPropagation();
//       closeLightbox();
//     });
    
//     // Close on overlay click (but not on image)
//     lightbox.overlay.addEventListener("click", (e) => {
//       if (e.target === lightbox.overlay || e.target === lightbox.container) {
//         closeLightbox();
//       }
//     });
    
//     // Close on escape key
//     document.addEventListener("keydown", function escHandler(e) {
//       if (e.key === "Escape") {
//         closeLightbox();
//         document.removeEventListener("keydown", escHandler);
//       }
//     });
    
//     // Add mouse wheel zoom support
//     lightbox.container.addEventListener("wheel", (e) => {
//       e.preventDefault();
//       e.stopPropagation();
      
//       if (e.deltaY < 0 && currentZoom < maxZoom) {
//         // Zoom in
//         currentZoom = Math.min(currentZoom + zoomStep, maxZoom);
//       } else if (e.deltaY > 0 && currentZoom > minZoom) {
//         // Zoom out
//         currentZoom = Math.max(currentZoom - zoomStep, minZoom);
        
//         // Reset position if we're back to minZoom
//         if (currentZoom === minZoom) {
//           currentX = 0;
//         }
//       }
      
//       updateTransform();
//     });
    
//     // Add touch events for horizontal panning only when zoomed in
//     let lastTouchX = 0;
//     let isDragging = false;
    
//     // Handle touch start for panning
//     lightboxImage.addEventListener("touchstart", (e) => {
//       if (e.touches.length === 1 && currentZoom > 1) {
//         // Only enable panning when zoomed in
//         const touch = e.touches[0];
//         lastTouchX = touch.clientX;
//         isDragging = true;
//       }
//     });
    
//     // Handle touch move for horizontal panning only
//     lightboxImage.addEventListener(
//       "touchmove",
//       (e) => {
//         if (isDragging && e.touches.length === 1 && currentZoom > 1) {
//           e.preventDefault(); // Prevent scrolling when panning
          
//           const touch = e.touches[0];
          
//           // Calculate how much the touch has moved horizontally
//           const deltaX = touch.clientX - lastTouchX;
          
//           // Update the last touch position
//           lastTouchX = touch.clientX;
          
//           // Calculate max panning distance based on image width and zoom level
//           const maxPanX = (lightboxImage.offsetWidth * (currentZoom - 1)) / 2;
          
//           // Update the horizontal position with constraints
//           currentX = Math.min(Math.max(currentX + deltaX, -maxPanX), maxPanX);
          
//           updateTransform();
//         }
//       },
//       { passive: false },
//     );
    
//     // Handle touch end
//     lightboxImage.addEventListener("touchend", () => {
//       isDragging = false;
//     });
//   }
// });

// Size Chart
document.addEventListener("DOMContentLoaded", () => {
  // Add CSS styles directly in JavaScript
  const styleElement = document.createElement("style");
  styleElement.textContent = `
    /* Lightbox overlay */
    .lightbox-overlay {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.85);
      z-index: 9999;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    
    /* Lightbox container */
    .lightbox-container {
      position: relative;
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }
    
    /* Action buttons container */
    .lightbox-actions {
      position: absolute;
      top: 20px;
      right: 20px;
      display: flex;
      gap: 10px;
      z-index: 10;
    }
    
    /* Action button style */
    .lightbox-action-button {
      width: 40px;
      height: 40px;
      border-radius: 50%;
      background-color: rgba(0, 0, 0, 0.5);
      border: none;
      color: white;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      transition: background-color 0.2s;
    }
    
    .lightbox-action-button:hover {
      background-color: rgba(0, 0, 0, 0.7);
    }
    
    .lightbox-action-button svg {
      width: 20px;
      height: 20px;
    }
    
    /* Image style */
    .lightbox-image {
      max-width: 90%;
      max-height: 80vh;
      transition: transform 0.2s ease;
      transform-origin: center center;
    }

    /* Caption / Toggle container */
    .lightbox-caption {
      position: absolute;
      bottom: 40px;
      left: 0;
      right: 0;
      text-align: center;
      color: white;
      font-size: 16px;
      font-weight: 600;
      background-color: rgba(0, 0, 0, 0.3);
      padding: 8px 12px;
      margin: 0 auto;
      max-width: fit-content;
      border-radius: 999px;
      display: flex;
      align-items: center;
      gap: 10px;
      user-select: none;
    }

    .lightbox-unit-toggle {
      display: inline-flex;
      gap: 6px;
      align-items: center;
    }

    .lightbox-unit-btn {
      appearance: none;
      border: 1px solid rgba(255,255,255,0.35);
      background: rgba(255,255,255,0.08);
      color: #fff;
      font-size: 13px;
      font-weight: 700;
      padding: 6px 12px;
      border-radius: 999px;
      cursor: pointer;
      transition: background 0.15s ease, border-color 0.15s ease;
    }

    .lightbox-unit-btn:hover {
      background: rgba(255,255,255,0.14);
      border-color: rgba(255,255,255,0.55);
    }

    .lightbox-unit-btn.is-active {
      background: rgba(255,255,255,0.92);
      color: #000;
      border-color: rgba(255,255,255,0.92);
    }
  `;
  document.head.appendChild(styleElement);

  // Find or wait for the foxkit button
  function findFoxkitButton() {
    const foxkitButton = document.querySelector(".foxkit-sizechart-button");

    if (foxkitButton) {
      setupFoxkitButton(foxkitButton);
    } else {
      setTimeout(findFoxkitButton, 500);
    }
  }

  findFoxkitButton();

  function setupFoxkitButton(foxkitButton) {
    const newButton = foxkitButton.cloneNode(true);
    foxkitButton.parentNode.replaceChild(newButton, foxkitButton);

    newButton.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation();
      showSizeChart();
      return false;
    });
  }

  // Helper: pick CM/IN images from popup
  function getUnitImagesFromPopup(sizeChartPopup) {
    const imgs = Array.from(sizeChartPopup.querySelectorAll(".size-chart-content img"));
    if (!imgs.length) return { cm: null, in: null };

    const byDataUnit = (unit) => imgs.find((img) => (img.getAttribute("data-unit") || "").toLowerCase() === unit);
    const byAlt = (unit) => imgs.find((img) => ((img.getAttribute("alt") || "") + "").toLowerCase().includes(unit));

    let cmImg = byDataUnit("cm") || byAlt("cm") || null;
    let inImg = byDataUnit("in") || byAlt("in") || byAlt("inch") || null;

    // Fallback: if two images exist and nothing identified, assume [0]=CM, [1]=IN
    if (!cmImg && !inImg && imgs.length >= 2) {
      cmImg = imgs[0];
      inImg = imgs[1];
    }

    // If only one image exists, both will be that (toggle will be hidden)
    if (!cmImg && imgs.length) cmImg = imgs[0];
    if (!inImg && imgs.length) inImg = imgs[0];

    return { cm: cmImg, in: inImg };
  }

  // Helper: swap lightbox image to a source image (keeps your lightbox image node)
  function applyImageFrom(lightboxImage, srcImg) {
  if (!srcImg) return;

  const isMobile = window.matchMedia("(max-width: 767px)").matches;

  // Prefer mobile src if available and screen is mobile
  const mobileSrc = srcImg.getAttribute("data-mobile-src");
  const src = (isMobile && mobileSrc) ? mobileSrc : srcImg.getAttribute("src");

  const srcset = srcImg.getAttribute("srcset");
  const sizes = srcImg.getAttribute("sizes");

  if (src) lightboxImage.setAttribute("src", src);
  if (srcset) lightboxImage.setAttribute("srcset", srcset);
  if (sizes) lightboxImage.setAttribute("sizes", sizes);

  lightboxImage.removeAttribute("loading");
  lightboxImage.removeAttribute("fetchpriority");
}


  function showSizeChart() {
    const sizeChartPopup = document.getElementById("size-chart-popup");
    if (!sizeChartPopup) return;

    const { cm: cmImg, in: inImg } = getUnitImagesFromPopup(sizeChartPopup);
    if (!cmImg) return;

    const lightbox = createLightbox();

    // Clone the image for the lightbox (start with CM by default)
    const lightboxImage = cmImg.cloneNode(true);
    applyImageFrom(lightboxImage, cmImg);
    lightboxImage.classList.add("lightbox-image");
    lightboxImage.style.pointerEvents = "auto";

    lightbox.container.appendChild(lightboxImage);

    // Build toggle (replaces caption)
    const captionElement = document.createElement("div");
    captionElement.classList.add("lightbox-caption");

    const toggleWrap = document.createElement("div");
    toggleWrap.classList.add("lightbox-unit-toggle");

    const cmBtn = document.createElement("button");
    cmBtn.type = "button";
    cmBtn.className = "lightbox-unit-btn is-active";
    cmBtn.textContent = "CM";

    const inBtn = document.createElement("button");
    inBtn.type = "button";
    inBtn.className = "lightbox-unit-btn";
    inBtn.textContent = "IN";

    // If we don't actually have a second distinct image, hide the toggle
    const hasTwoDistinct =
      inImg &&
      cmImg &&
      (inImg.getAttribute("src") !== cmImg.getAttribute("src") ||
        inImg.getAttribute("srcset") !== cmImg.getAttribute("srcset"));

    if (!hasTwoDistinct) {
      // Just show a simple label if only one image is available
      captionElement.textContent = "Size Chart";
    } else {
      toggleWrap.appendChild(cmBtn);
      toggleWrap.appendChild(inBtn);
      captionElement.appendChild(toggleWrap);
    }

    lightbox.container.appendChild(captionElement);

    // Wait for load then enable zoom/pan
    if (lightboxImage.complete) {
      setupInteractions(lightbox, lightboxImage, { cmImg, inImg, cmBtn, inBtn, hasTwoDistinct });
    } else {
      lightboxImage.onload = function () {
        setupInteractions(lightbox, lightboxImage, { cmImg, inImg, cmBtn, inBtn, hasTwoDistinct });
      };
    }
  }

  function createLightbox() {
    const lightboxOverlay = document.createElement("div");
    lightboxOverlay.classList.add("lightbox-overlay");

    const lightboxContainer = document.createElement("div");
    lightboxContainer.classList.add("lightbox-container");

    const lightboxActions = document.createElement("div");
    lightboxActions.classList.add("lightbox-actions");

    const zoomOutButton = document.createElement("button");
    zoomOutButton.classList.add("lightbox-action-button");
    zoomOutButton.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <line x1="5" y1="12" x2="19" y2="12"></line>
    </svg>`;
    zoomOutButton.setAttribute("aria-label", "Zoom Out");

    const resetButton = document.createElement("button");
    resetButton.classList.add("lightbox-action-button");
    resetButton.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M3 2v6h6"></path>
      <path d="M21 12A9 9 0 0 0 6 5.3L3 8"></path>
      <path d="M21 22v-6h-6"></path>
      <path d="M3 12a9 9 0 0 0 15 6.7l3-2.7"></path>
    </svg>`;
    resetButton.setAttribute("aria-label", "Reset Zoom");

    const zoomInButton = document.createElement("button");
    zoomInButton.classList.add("lightbox-action-button");
    zoomInButton.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <line x1="12" y1="5" x2="12" y2="19"></line>
      <line x1="5" y1="12" x2="19" y2="12"></line>
    </svg>`;
    zoomInButton.setAttribute("aria-label", "Zoom In");

    const closeButton = document.createElement("button");
    closeButton.classList.add("lightbox-action-button");
    closeButton.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <line x1="18" y1="6" x2="6" y2="18"></line>
      <line x1="6" y1="6" x2="18" y2="18"></line>
    </svg>`;
    closeButton.setAttribute("aria-label", "Close");

    lightboxActions.appendChild(zoomOutButton);
    lightboxActions.appendChild(resetButton);
    lightboxActions.appendChild(zoomInButton);
    lightboxActions.appendChild(closeButton);

    lightboxContainer.appendChild(lightboxActions);
    lightboxOverlay.appendChild(lightboxContainer);
    document.body.appendChild(lightboxOverlay);

    return {
      overlay: lightboxOverlay,
      container: lightboxContainer,
      actions: lightboxActions,
      zoomInButton,
      zoomOutButton,
      resetButton,
      closeButton,
    };
  }

  function setupInteractions(lightbox, lightboxImage, unitCtx = {}) {
    document.body.style.overflow = "hidden";

    let currentZoom = 1;
    let currentX = 0;
    const zoomStep = 0.1;
    const maxZoom = 1.4;
    const minZoom = 1;

    function updateTransform() {
      lightboxImage.style.transform = `translateX(${currentX}px) scale(${currentZoom})`;
    }

    function resetView() {
      currentZoom = 1;
      currentX = 0;
      updateTransform();
    }

    // Toggle wiring (CM/IN)
    if (unitCtx.hasTwoDistinct && unitCtx.cmBtn && unitCtx.inBtn && unitCtx.cmImg && unitCtx.inImg) {
      unitCtx.cmBtn.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        unitCtx.cmBtn.classList.add("is-active");
        unitCtx.inBtn.classList.remove("is-active");
        applyImageFrom(lightboxImage, unitCtx.cmImg);
        resetView();
      });

      unitCtx.inBtn.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        unitCtx.inBtn.classList.add("is-active");
        unitCtx.cmBtn.classList.remove("is-active");
        applyImageFrom(lightboxImage, unitCtx.inImg);
        resetView();
      });
    }

    lightbox.zoomInButton.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      if (currentZoom < maxZoom) {
        currentZoom = Math.min(currentZoom + zoomStep, maxZoom);
        updateTransform();
      }
    });

    lightbox.zoomOutButton.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      if (currentZoom > minZoom) {
        currentZoom = Math.max(currentZoom - zoomStep, minZoom);
        if (currentZoom === minZoom) currentX = 0;
        updateTransform();
      }
    });

    lightbox.resetButton.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      resetView();
    });

    function closeLightbox() {
      document.body.style.overflow = "";
      lightbox.overlay.remove();
    }

    lightbox.closeButton.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      closeLightbox();
    });

    lightbox.overlay.addEventListener("click", (e) => {
      if (e.target === lightbox.overlay || e.target === lightbox.container) {
        closeLightbox();
      }
    });

    document.addEventListener("keydown", function escHandler(e) {
      if (e.key === "Escape") {
        closeLightbox();
        document.removeEventListener("keydown", escHandler);
      }
    });

    lightbox.container.addEventListener("wheel", (e) => {
      e.preventDefault();
      e.stopPropagation();

      if (e.deltaY < 0 && currentZoom < maxZoom) {
        currentZoom = Math.min(currentZoom + zoomStep, maxZoom);
      } else if (e.deltaY > 0 && currentZoom > minZoom) {
        currentZoom = Math.max(currentZoom - zoomStep, minZoom);
        if (currentZoom === minZoom) currentX = 0;
      }
      updateTransform();
    });

    let lastTouchX = 0;
    let isDragging = false;

    lightboxImage.addEventListener("touchstart", (e) => {
      if (e.touches.length === 1 && currentZoom > 1) {
        const touch = e.touches[0];
        lastTouchX = touch.clientX;
        isDragging = true;
      }
    });

    lightboxImage.addEventListener(
      "touchmove",
      (e) => {
        if (isDragging && e.touches.length === 1 && currentZoom > 1) {
          e.preventDefault();
          const touch = e.touches[0];
          const deltaX = touch.clientX - lastTouchX;
          lastTouchX = touch.clientX;

          const maxPanX = (lightboxImage.offsetWidth * (currentZoom - 1)) / 2;
          currentX = Math.min(Math.max(currentX + deltaX, -maxPanX), maxPanX);

          updateTransform();
        }
      },
      { passive: false }
    );

    lightboxImage.addEventListener("touchend", () => {
      isDragging = false;
    });
  }
});

















// Product Page Title
// document.addEventListener('DOMContentLoaded', function() {
//   const productTitles = document.querySelectorAll('.product-page-hero-title-text, .page-banner-title-text');
  
//   if (productTitles.length > 0) {
//     productTitles.forEach(titleElement => {
//       const title = titleElement.textContent.trim();
      
//       // Split by spaces to get words
//       const words = title.split(' ');
      
//       // Check if the element has page-banner-title-text class
//       if (titleElement.classList.contains('page-banner-title-text')) {
//         // Special handling for page-banner-title-text class
//         if (words.length >= 1) {
//           // 1. First word gets caps-t class and is uppercase
//           const firstPart = `<span class="caps-t">${words[0].toUpperCase()}</span>`;
          
//           // 2. Second word gets last-t class
//           let secondPart = '';
//           if (words.length >= 2) {
//             secondPart = ` <span class="last-t">${words[1]}</span>`;
//           }
          
//           // 3. Any additional words get last-t class
//           let additionalParts = '';
//           if (words.length > 2) {
//             for (let i = 2; i < words.length; i++) {
//               additionalParts += ` <span class="last-t">${words[i]}</span>`;
//             }
//           }
          
//           // Combine all parts
//           titleElement.innerHTML = `${firstPart}${secondPart}${additionalParts}`;
//         }
//       }
//       // Check if the element has both product-page-hero-title-text and text-v2 classes
//       else if (titleElement.classList.contains('text-v2')) {
//         // Special handling for elements with both classes
//         if (words.length >= 3) {
//           // 1. First word gets top-t class
//           const firstPart = `<span class="top-t">${words[0]}</span>`;
          
//           // 2. Second word gets last-t class
//           const secondPart = `<span class="last-t">${words[1]}</span>`;
          
//           // 3. Third word and beyond get caps-t class and are uppercase
//           let additionalParts = '';
//           if (words.length >= 3) {
//             for (let i = 2; i < words.length; i++) {
//               additionalParts += ` <span class="caps-t">${words[i].toUpperCase()}</span>`;
//             }
//           }
          
//           // Combine all parts
//           titleElement.innerHTML = `${firstPart} ${secondPart}${additionalParts}`;
//         }
//       } else {
//         // Original logic for elements with only product-page-hero-title-text class
//         if (words.length >= 3) {
//           // 1. First word gets top-t class
//           const firstPart = `<span class="top-t">${words[0]}</span>`;
          
//           // 2. Second word gets caps-t class and is uppercase
//           const middlePart = `<span class="caps-t">${words[1].toUpperCase()}</span>`;
          
//           // 3. Third word gets last-t class
//           const lastPart = `<span class="last-t">${words[2]}</span>`;
          
//           // 4. Any additional words (4th, 5th, 6th, etc.) get last-t class and are concatenated in order
//           let additionalParts = '';
//           if (words.length > 3) {
//             for (let i = 3; i < words.length; i++) {
//               additionalParts += ` <span class="last-t">${words[i]}</span>`;
//             }
//           }
          
//           // Combine all parts
//           titleElement.innerHTML = `${firstPart} ${middlePart} ${lastPart}${additionalParts}`;
//         }
//       }
//     });
//   }
// });
document.addEventListener('DOMContentLoaded', function() {
  const productTitles = document.querySelectorAll('.product-page-hero-title-text, .page-banner-title-text');

  if (productTitles.length > 0) {
    productTitles.forEach(titleElement => {
      const title = titleElement.textContent.trim();
      const words = title.split(' ');

      // ---------------------------
      // CASE 1: Banner Title Logic
      // ---------------------------
      if (titleElement.classList.contains('page-banner-title-text')) {
        if (words.length >= 1) {
          const firstPart = `<span class="caps-t">${words[0].toUpperCase()}</span>`;
          
          let rest = '';
          for (let i = 1; i < words.length; i++) {
            rest += ` <span class="last-t">${words[i]}</span>`;
          }

          titleElement.innerHTML = firstPart + rest;
        }
      }

      // -----------------------------------------------
      // CASE 2: Hero Title + text-v2 (special handling)
      // -----------------------------------------------
      else if (titleElement.classList.contains('text-v2')) {
        if (words.length >= 2) {
          const firstPart = `<span class="top-t">${words[0]}</span>`;
          const secondPart = `<span class="caps-t">${words[1]}</span>`;

          let additional = '';
          for (let i = 2; i < words.length; i++) {
            additional += ` <span class="last-t">${words[i].toUpperCase()}</span>`;
          }

          titleElement.innerHTML = `${firstPart} ${secondPart}${additional}`;
        }
      }

      // ---------------------------------------------------
      // CASE 3: Default product-page-hero-title-text logic
      // Now supports 2 words AND 3+ words
      // ---------------------------------------------------
      else {
        if (words.length === 1) {
          // Only one word → treat it as caps-t
          titleElement.innerHTML = `<span class="caps-t">${words[0]}</span>`;
        }

        else if (words.length === 2) {
          // NEW: Handle 2-word titles
          const firstPart = `<span class="top-t">${words[0]}</span>`;
          const secondPart = `<span class="caps-t">${words[1].toUpperCase()}</span>`;
          titleElement.innerHTML = `${firstPart} ${secondPart}`;
        }

        else if (words.length >= 3) {
          // Existing 3-word logic
          const firstPart = `<span class="top-t">${words[0]}</span>`;
          const middlePart = `<span class="caps-t">${words[1].toUpperCase()}</span>`;
          const thirdPart = `<span class="last-t">${words[2]}</span>`;

          let additionalParts = '';
          for (let i = 3; i < words.length; i++) {
            additionalParts += ` <span class="last-t">${words[i]}</span>`;
          }

          titleElement.innerHTML = `${firstPart} ${middlePart} ${thirdPart}${additionalParts}`;
        }
      }
    });
  }
});







// Bamboo tee product card video viewport play js
(function() {
  // Override the HTMLMediaElement.prototype.play method
  const originalPlay = HTMLMediaElement.prototype.play;
  
  HTMLMediaElement.prototype.play = function() {
    // Check if this video should be allowed to play
    if (this.hasAttribute('data-allowed-to-play')) {
      // Always hide controls
      this.controls = false;
      return originalPlay.apply(this);
    } else {
      // Prevent playing and return a rejected promise
      return new Promise((resolve, reject) => {
        reject(new DOMException('Play prevented', 'NotAllowedError'));
      });
    }
  };
  
  // Function to improve video poster quality
  function enhanceVideoPoster(video) {
    // Get current poster if it exists
    const currentPoster = video.getAttribute('poster');
    
    if (currentPoster) {
      // Common patterns for low quality images in ecommerce platforms
      const patterns = [
        // Replace patterns based on your platform's naming convention
        { regex: /_small\.jpg/i, replacement: '_2000x.jpg' },
        { regex: /_100x\.jpg/i, replacement: '_2000x.jpg' },
        { regex: /_200x\.jpg/i, replacement: '_2000x.jpg' },
        { regex: /_300x\.jpg/i, replacement: '_2000x.jpg' },
        { regex: /_360x\.jpg/i, replacement: '_2000x.jpg' },
        { regex: /_460x\.jpg/i, replacement: '_2000x.jpg' },
        { regex: /_480x\.jpg/i, replacement: '_2000x.jpg' },
        { regex: /_540x\.jpg/i, replacement: '_2000x.jpg' },
        { regex: /_640x\.jpg/i, replacement: '_2000x.jpg' },
        { regex: /_800x\.jpg/i, replacement: '_2000x.jpg' },
        { regex: /_1000x\.jpg/i, replacement: '_2000x.jpg' },
        { regex: /_thumb\.jpg/i, replacement: '.jpg' },
        { regex: /_low\.jpg/i, replacement: '.jpg' },
        { regex: /_preview\.jpg/i, replacement: '.jpg' },
        { regex: /\?width=\d+/i, replacement: '?width=2000' },
        { regex: /\?w=\d+/i, replacement: '?w=2000' },
        { regex: /\?quality=\d+/i, replacement: '?quality=100' }
      ];
      
      // Try to create a higher quality version of the poster URL
      let highQualityPoster = currentPoster;
      
      for (const pattern of patterns) {
        if (pattern.regex.test(highQualityPoster)) {
          highQualityPoster = highQualityPoster.replace(pattern.regex, pattern.replacement);
          break; // Apply only one transformation to avoid multiple replacements
        }
      }
      
      // If we created a different URL, use it
      if (highQualityPoster !== currentPoster) {
        video.setAttribute('poster', highQualityPoster);
      }
      
      // Add styling to ensure poster fits correctly
      video.style.objectFit = 'cover';
    }
  }
  
  // Handle videos as soon as they're added to the DOM
  function handleExistingVideos() {
    const videos = document.querySelectorAll('video');
    videos.forEach(video => {
      // Immediately pause any playing videos
      if (!video.paused) {
        video.pause();
      }
      
      // Remove autoplay attribute
      video.autoplay = false;
      video.removeAttribute('autoplay');
      
      // Always hide controls
      video.controls = false;
      
      // Enhance poster image quality
      enhanceVideoPoster(video);
      
      // Add attribute to allow styling the video container based on play state
      video.addEventListener('play', () => {
        video.parentElement?.setAttribute('data-video-playing', 'true');
      });
      
      video.addEventListener('pause', () => {
        video.parentElement?.removeAttribute('data-video-playing');
      });
    });
  }
  
  // Call immediately
  handleExistingVideos();
  
  // Also call when DOM content is loaded
  document.addEventListener('DOMContentLoaded', function() {
    handleExistingVideos();
    
    // Set up IntersectionObserver
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        const video = entry.target;
        
        if (entry.isIntersecting) {
          // Allow this video to play
          video.setAttribute('data-allowed-to-play', 'true');
          // Try to play
          originalPlay.apply(video).catch(e => console.log('Video play error:', e));
        } else {
          // Disallow playing and pause
          video.removeAttribute('data-allowed-to-play');
          video.pause();
        }
      });
    }, { threshold: 0.5 });
    
    // Observe all videos
    const videos = document.querySelectorAll('video');
    videos.forEach(video => {
      observer.observe(video);
      
      // Always hide controls
      video.controls = false;
      
      // Enhance poster image quality
      enhanceVideoPoster(video);
    });
    
    // Set up mutation observer to catch new videos
    const mutationObserver = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        if (mutation.addedNodes.length) {
          mutation.addedNodes.forEach(node => {
            // Check if the added node is a video or contains videos
            if (node.nodeName === 'VIDEO') {
              node.pause();
              node.autoplay = false;
              node.removeAttribute('autoplay');
              node.controls = false;
              enhanceVideoPoster(node);
              observer.observe(node);
            } else if (node.querySelectorAll) {
              const newVideos = node.querySelectorAll('video');
              newVideos.forEach(video => {
                video.pause();
                video.autoplay = false;
                video.removeAttribute('autoplay');
                video.controls = false;
                enhanceVideoPoster(video);
                observer.observe(video);
              });
            }
          });
        }
      });
    });
    
    // Observe the entire document for new videos
    mutationObserver.observe(document.body, { 
      childList: true,
      subtree: true
    });
  });
  
  // Add a style to hide default controls and improve poster display
  const style = document.createElement('style');
  style.textContent = `
    video::-webkit-media-controls {
      display: none !important;
    }
    video::-webkit-media-controls-enclosure {
      display: none !important;
    }
    video::-webkit-media-controls-panel {
      display: none !important;
    }
    video::-webkit-media-controls-play-button {
      display: none !important;
    }
    video::-webkit-media-controls-timeline {
      display: none !important;
    }
    video::-webkit-media-controls-current-time-display {
      display: none !important;
    }
    video::-webkit-media-controls-time-remaining-display {
      display: none !important;
    }
    video::-webkit-media-controls-mute-button {
      display: none !important;
    }
    video::-webkit-media-controls-toggle-closed-captions-button {
      display: none !important;
    }
    video::-webkit-media-controls-volume-slider {
      display: none !important;
    }
    video::-webkit-media-controls-fullscreen-button {
      display: none !important;
    }
    video {
      pointer-events: none !important;
      object-fit: cover !important;
      width: 100% !important;
      height: 100% !important;
    }
    
    /* Ensure containers are correctly sized for posters */
    [data-video-container] {
      position: relative;
      overflow: hidden;
    }
  `;
  document.head.appendChild(style);
})();







// Add smooth scrolling behavior for mobile swipe (search)
// Product Slider for Mobile Devices
document.addEventListener('DOMContentLoaded', function() {
  const isMobile = window.innerWidth < 768;
  if (!isMobile) return;

  // Find the slider
  const sliderContainer = document.querySelector('.m-search-featured-collection__slider');
  if (!sliderContainer) return;

  const slides = sliderContainer.querySelectorAll('.m-search-featured-collection__slide');
  const slideCount = slides.length;
  
  if (slideCount === 0) return;
  
  // Create dot indicators
  const dotsContainer = document.querySelector('.slider-dots');
  if (dotsContainer) {
    for (let i = 0; i < slideCount; i++) {
      const dot = document.createElement('div');
      dot.classList.add('slider-dot');
      if (i === 0) dot.classList.add('active');
      dot.dataset.index = i;
      dotsContainer.appendChild(dot);
    }
  }
  
  // Set the first slide as active
  let currentSlide = 0;
  slides[currentSlide].classList.add('active');
  
  // Navigation buttons
  const prevButton = document.querySelector('.slider-prev');
  const nextButton = document.querySelector('.slider-next');
  
  // Function to change slide
  function goToSlide(index) {
    // Remove active class from all slides
    slides.forEach(slide => {
      slide.classList.remove('active');
    });
    
    // Add active class to the current slide
    slides[index].classList.add('active');
    
    // Update dots
    const dots = document.querySelectorAll('.slider-dot');
    dots.forEach(dot => {
      dot.classList.remove('active');
    });
    dots[index].classList.add('active');
    
    currentSlide = index;
  }
  
  // Event listeners for navigation buttons
  if (prevButton) {
    prevButton.addEventListener('click', () => {
      let newIndex = currentSlide - 1;
      if (newIndex < 0) newIndex = slideCount - 1;
      goToSlide(newIndex);
    });
  }
  
  if (nextButton) {
    nextButton.addEventListener('click', () => {
      let newIndex = currentSlide + 1;
      if (newIndex >= slideCount) newIndex = 0;
      goToSlide(newIndex);
    });
  }
  
  // Event listeners for dots
  const dots = document.querySelectorAll('.slider-dot');
  dots.forEach(dot => {
    dot.addEventListener('click', () => {
      goToSlide(parseInt(dot.dataset.index));
    });
  });
  
  // Touch swipe functionality
  let touchStartX = 0;
  let touchEndX = 0;
  
  sliderContainer.addEventListener('touchstart', (e) => {
    touchStartX = e.changedTouches[0].screenX;
  }, { passive: true });
  
  sliderContainer.addEventListener('touchend', (e) => {
    touchEndX = e.changedTouches[0].screenX;
    handleSwipe();
  }, { passive: true });
  
  function handleSwipe() {
    const swipeThreshold = 50;
    
    if (touchEndX < touchStartX - swipeThreshold) {
      // Swipe left - go to next slide
      let newIndex = currentSlide + 1;
      if (newIndex >= slideCount) newIndex = 0;
      goToSlide(newIndex);
    }
    
    if (touchEndX > touchStartX + swipeThreshold) {
      // Swipe right - go to previous slide
      let newIndex = currentSlide - 1;
      if (newIndex < 0) newIndex = slideCount - 1;
      goToSlide(newIndex);
    }
  }
  
  // Auto-play functionality (optional)
  /*
  let slideInterval = setInterval(() => {
    let newIndex = currentSlide + 1;
    if (newIndex >= slideCount) newIndex = 0;
    goToSlide(newIndex);
  }, 5000);
  
  // Pause auto-play on interaction
  sliderContainer.addEventListener('mouseenter', () => {
    clearInterval(slideInterval);
  });
  
  sliderContainer.addEventListener('mouseleave', () => {
    slideInterval = setInterval(() => {
      let newIndex = currentSlide + 1;
      if (newIndex >= slideCount) newIndex = 0;
      goToSlide(newIndex);
    }, 5000);
  });
  */
});



// Login menu link
// (function() {
//   // One-time CSS solution to hide overlays
//   const style = document.createElement('style');
//   style.textContent = `
//     cad-overlay[data-type="login"],
//     .cad-overlay[data-type="login"],
//     cad-overlay[data-type="register"],
//     .cad-overlay[data-type="register"] {
//       display: none !important;
//     }
//   `;
//   document.head.appendChild(style);
  
//   // Initial fix for all relevant buttons
//   function fixButtons() {
//     // Desktop account link
//     const accountLink = document.querySelector('a.m-header__account');
//     if (accountLink && accountLink.hasAttribute('cad-overlay-trigger')) {
//       accountLink.removeAttribute('cad-overlay-trigger');
//     }
    
//     // Mobile signin button
//     const signinButton = document.querySelector('a.m-signin-button');
//     if (signinButton && signinButton.hasAttribute('cad-overlay-trigger')) {
//       signinButton.removeAttribute('cad-overlay-trigger');
//     }
    
//     // Mobile register button
//     const registerButton = document.querySelector('a.m-register-button');
//     if (registerButton && registerButton.hasAttribute('cad-overlay-trigger')) {
//       registerButton.removeAttribute('cad-overlay-trigger');
//     }
//   }
  
//   // Run the initial fix
//   fixButtons();
  
//   // Event delegation for all buttons
//   document.addEventListener('click', function(e) {
//     // Quick check - is this potentially a link?
//     if (e.target.tagName === 'A' || e.target.closest('a')) {
//       const clickedLink = e.target.tagName === 'A' ? e.target : e.target.closest('a');
      
//       // Check for account link (desktop)
//       if (clickedLink.classList.contains('m-header__account')) {
//         e.stopPropagation();
//         e.preventDefault();
        
//         const currentPath = window.location.pathname;
//         const targetPath = '/apps/deluxe/account/login';
        
//         if (currentPath !== targetPath) {
//           window.location.href = targetPath;
//         }
//         return false;
//       }
      
//       // Check for signin button (mobile)
//       if (clickedLink.classList.contains('m-signin-button')) {
//         e.stopPropagation();
//         e.preventDefault();
        
//         const currentPath = window.location.pathname;
//         const targetPath = '/apps/deluxe/account/login';
        
//         if (currentPath !== targetPath) {
//           window.location.href = targetPath;
//         }
//         return false;
//       }
      
//       // Check for register button (mobile)
//       if (clickedLink.classList.contains('m-register-button')) {
//         e.stopPropagation();
//         e.preventDefault();
        
//         const currentPath = window.location.pathname;
//         const targetPath = '/apps/deluxe/account/register';
        
//         if (currentPath !== targetPath) {
//           window.location.href = targetPath;
//         }
//         return false;
//       }
//     }
//   }, true);
  
//   // Clean up existing observer if it exists
//   if (window._buttonsObserver) {
//     window._buttonsObserver.disconnect();
//   }
  
//   // Set up an observer to watch for DOM changes
//   const observer = new MutationObserver(fixButtons);
//   window._buttonsObserver = observer;
  
//   // Target the header area for better performance
//   const header = document.querySelector('header') || document.querySelector('.header') || document.body;
//   observer.observe(header, { attributes: true, childList: true, subtree: true });
// })();





// Bundle Remove JS based on URL
// Configuration: Array of page patterns to check
// const pagesConfig = [
//   'yoga-bundle',
//   // Add more pages here in the future
// ];

// // Get the current page URL just once
// const currentPageURL = window.location.href;
// const urlParams = new URLSearchParams(window.location.search);

// // Check early if we need to redirect - do this before DOM is fully loaded
// (function() {
//   // Fast check using pathname instead of full URL comparison
//   const pathname = window.location.pathname;
  
//   // Check if we're on a relevant page using pathname for efficiency
//   const isRelevantPage = pagesConfig.some(page => pathname.includes(`/pages/${page}/`));
  
//   if (isRelevantPage) {
//     // Check if there is no gender parameter - using URLSearchParams for better performance
//     if (!urlParams.has('him') && !urlParams.has('her')) {
//       // Redirect immediately without waiting for DOMContentLoaded
//       window.location.href = '/pages/athlos-wardrobe/';
//       return; // Exit early
//     }
//   }
// })();

// // Only run the DOM manipulation if we didn't redirect
// // Use a more efficient event listener if the page is already loaded
// const runPageModifications = function() {
//   // Get gender parameters once
//   const hasHimParam = urlParams.has('him');
//   const hasHerParam = urlParams.has('her');
  
//   // Apply DOM changes based on parameters - using more efficient selectors
//   if (hasHimParam) {
//     // Remove the "her" bundle when "him" is in the URL
//     document.querySelectorAll('.bundle-product-her').forEach(element => {
//       element.parentNode.removeChild(element);
     
//     });
//   } 
  
//   if (hasHerParam) {
//     // Remove the "him" bundle when "her" is in the URL
//     document.querySelectorAll('.bundle-product-him').forEach(element => {
//       element.parentNode.removeChild(element);
//     });
//   }
// };

// // Check if DOM is already loaded
// if (document.readyState === 'loading') {
//   document.addEventListener('DOMContentLoaded', runPageModifications);
// } else {
//   // DOM is already loaded, run immediately
//   runPageModifications();
// }












// wishlist code
// document.addEventListener('DOMContentLoaded', function () {
//   const wishlistItems = document.querySelectorAll('.grid__item');

//   wishlistItems.forEach(item => {
//     const link = item.querySelector('a.full-unstyled-link');
//     const moveToCartBtn = item.querySelector('.add-to-cart-button');
//     if (!link || !moveToCartBtn) return;

//     const href = link.getAttribute('href');
//     const match = href.match(/\/products\/([^\/]+)/);
//     if (!match) return;

//     const handle = match[1];
//     const productId = moveToCartBtn.dataset.productId;

//     fetch(`/products/${handle}.js`)
//       .then(res => res.json())
//       .then(product => {
//         const optionSelectors = [];
//         const variantContainer = document.createElement('div');
//         variantContainer.className = 'variant-dropdowns';

//         product.options.forEach((option, optionIndex) => {
//           const wrapper = document.createElement('div');
//           wrapper.className = 'variant-select-wrapper';

//           const label = document.createElement('label');
//           label.textContent = option.name; // FIX: Use option.name, not whole object

//           const select = document.createElement('select');
//           select.setAttribute('data-option-index', optionIndex);
//           select.className = 'variant-option';

//           const values = [...new Set(product.variants.map(v => v[`option${optionIndex + 1}`]))];
//           values.forEach(value => {
//             const opt = document.createElement('option');
//             opt.value = value;
//             opt.textContent = value;
//             select.appendChild(opt);
//           });

//           wrapper.appendChild(label);
//           wrapper.appendChild(select);
//           variantContainer.appendChild(wrapper);
//           optionSelectors.push(select);
//         });

//         moveToCartBtn.parentNode.insertBefore(variantContainer, moveToCartBtn);

//         moveToCartBtn.addEventListener('click', (e) => {
//           e.preventDefault();

//           const selectedOptions = optionSelectors.map(select => select.value);
//           const variant = product.variants.find(v =>
//             selectedOptions.every((val, i) => val === v[`option${i + 1}`])
//           );

//           if (!variant) {
//             alert('Variant not found for selected options');
//             return;
//           }

//           moveToCartBtn.querySelector('.add-to-cart-text').style.display = 'none';
//           moveToCartBtn.querySelector('.adding-to-cart-text').style.display = 'inline';

//           fetch('/cart/add.js', {
//             method: 'POST',
//             headers: {
//               'Content-Type': 'application/json'
//             },
//             body: JSON.stringify({
//               items: [{
//                 id: variant.id,
//                 quantity: 1
//               }]
//             })
//           })
//           .then(res => res.json())
//           .then(() => {
//             fetch('/apps/wishlists', {
//               method: 'POST',
//               headers: {
//                 'Content-Type': 'application/json'
//               },
//               body: JSON.stringify({
//                 itemId: productId,
//                 action: 'remove'
//               })
//             }).then(() => {
//               item.remove();
//             });
//           });
//         });
//       });
//   });
// });

document.addEventListener('DOMContentLoaded', function () {
  const wishlistItems = document.querySelectorAll('.wishlist-grid .grid__item');


  wishlistItems.forEach(item => {
    const link = item.querySelector('a.full-unstyled-link');
    const moveToCartBtn = item.querySelector('.add-to-cart-button');
    if (!link || !moveToCartBtn) return;

    const href = link.getAttribute('href');
    const match = href.match(/\/products\/([^\/]+)/);
    if (!match) return;

    const handle = match[1];

    // Fetch product data to get variants
    fetch(`/products/${handle}.js`)
      .then(res => res.json())
      .then(product => {
        // Create variant dropdowns
        const optionSelectors = [];
        const variantContainer = document.createElement('div');
        variantContainer.className = 'variant-dropdowns';

        // Create dropdowns for each option
        product.options.forEach((option, optionIndex) => {
          const wrapper = document.createElement('div');
          wrapper.className = 'variant-select-wrapper';

          const label = document.createElement('label');
          label.textContent = option.name;

          const select = document.createElement('select');
          select.setAttribute('data-option-index', optionIndex);
          select.className = 'variant-option';

          // Initially populate with all values for this option
          const values = [...new Set(product.variants.map(v => v[`option${optionIndex + 1}`]))];
          values.forEach(value => {
            const opt = document.createElement('option');
            opt.value = value;
            opt.textContent = value;
            select.appendChild(opt);
          });

          wrapper.appendChild(label);
          wrapper.appendChild(select);
          variantContainer.appendChild(wrapper);
          optionSelectors.push(select);

          // Add change event to update subsequent dropdowns
          select.addEventListener('change', function() {
            // Only update dropdowns that come after this one
            updateSubsequentDropdowns(product, optionSelectors, optionIndex);
          });
        });

        // Insert variant dropdowns before the "Move to Cart" button
        moveToCartBtn.parentNode.insertBefore(variantContainer, moveToCartBtn);

        // Initialize the dropdowns in hierarchical order
        if (optionSelectors.length > 1) {
          updateSubsequentDropdowns(product, optionSelectors, 0);
        }

        // Modify the original click handler to use the selected variant
        const originalClickHandler = moveToCartBtn.onclick;
        moveToCartBtn.onclick = function(e) {
          // Get selected variant
          const selectedOptions = optionSelectors.map(select => select.value);
          const variant = findVariantByOptions(product.variants, selectedOptions);

          if (!variant) {
            alert('Variant not found for selected options');
            e.preventDefault();
            return;
          }
          
          // Replace the form's variant ID with the selected one
          const formOrButton = moveToCartBtn.closest('form') || moveToCartBtn;
          const variantInput = formOrButton.querySelector('input[name="id"]');
          if (variantInput) {
            variantInput.value = variant.id;
          } else {
            // If there's no input field, add one
            const input = document.createElement('input');
            input.type = 'hidden';
            input.name = 'id';
            input.value = variant.id;
            formOrButton.appendChild(input);
          }
          
          // Let the original handler or form submission continue
          if (typeof originalClickHandler === 'function') {
            originalClickHandler.call(this, e);
          }
          
          // Update cart count after a short delay to ensure cart is updated
          setTimeout(updateCartCount, 500);
          // Try again after a longer delay in case of slow network
          setTimeout(updateCartCount, 1500);
        };
      });
  });
  
  // Function to find a variant by selected options
  function findVariantByOptions(variants, selectedOptions) {
    return variants.find(variant => {
      return selectedOptions.every((option, index) => {
        return variant[`option${index + 1}`] === option;
      });
    });
  }
  
  // Function to update dropdowns that come after the changed one
  function updateSubsequentDropdowns(product, optionSelectors, changedIndex) {
    // Get current selections up to the changed dropdown
    const currentSelections = optionSelectors.map((select, index) => {
      return index <= changedIndex ? select.value : null;
    });
    
    // Update each dropdown that comes after the changed one
    for (let i = changedIndex + 1; i < optionSelectors.length; i++) {
      const select = optionSelectors[i];
      
      // Save current selection
      const currentValue = select.value;
      
      // Get available values for this option based on previous selections
      const availableValues = getAvailableValuesForOption(product, i, currentSelections);
      
      // Clear the dropdown
      while (select.options.length > 0) {
        select.remove(0);
      }
      
      // Repopulate with available values
      availableValues.forEach(value => {
        const opt = document.createElement('option');
        opt.value = value;
        opt.textContent = value;
        select.appendChild(opt);
      });
      
      // Select first option by default
      if (select.options.length > 0) {
        select.selectedIndex = 0;
        // Update the current selections for next dropdown
        currentSelections[i] = select.value;
      }
    }
  }
  
  // Function to get available values for an option based on previous selections
  function getAvailableValuesForOption(product, optionIndex, currentSelections) {
    // Find variants that match the current selections for previous options
    const matchingVariants = product.variants.filter(variant => {
      return currentSelections.every((selection, i) => {
        // Only check options before the current one
        if (i >= optionIndex) return true;
        // Only check if a selection has been made
        if (!selection) return true;
        return variant[`option${i + 1}`] === selection;
      });
    });
    
    // Extract unique values for this option from matching variants
    const availableValues = [...new Set(matchingVariants.map(v => v[`option${optionIndex + 1}`]))];
    return availableValues;
  }
  
  // Function to update cart count - copied directly from your bundle product slider code
  function updateCartCount() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const cartCount = cart.item_count;
        console.log("Cart count updated to:", cartCount);
        
        // Try all possible selectors for cart count elements
        const countSelectors = [
          '.m-cart-count', 
          '.cart-count',
          '.cart-items-count',
          '.header__cart-count',
          '[data-cart-count]',
          '.site-header__cart-count span',
          '.cart-count-bubble span'
        ];
        
        // Apply count to all possible elements
        countSelectors.forEach(selector => {
          const elements = document.querySelectorAll(selector);
          elements.forEach(elem => {
            elem.textContent = cartCount.toString();
            
            // Also set data attribute if it exists
            if (elem.hasAttribute('data-cart-count')) {
              elem.setAttribute('data-cart-count', cartCount.toString());
            }
            
            // Show the element if it has items
            if (cartCount > 0) {
              const bubble = elem.closest('.m-cart-count-bubble, .cart-count-bubble');
              if (bubble) {
                bubble.style.display = '';
                bubble.classList.remove('hidden', 'm:hidden');
              }
              elem.style.display = '';
              elem.classList.remove('hidden');
            }
          });
        });
        
        // For Minimog theme specifically
        document.querySelectorAll('.m-cart-count-bubble').forEach(bubble => {
          if (cartCount > 0) {
            bubble.classList.remove('m:hidden', 'hidden');
            const countElem = bubble.querySelector('.m-cart-count');
            if (countElem) {
              countElem.textContent = cartCount.toString();
            }
          }
        });
        
        // Force a DOM reflow to ensure the count displays
        document.body.offsetHeight;
      })
      .catch(error => {
        console.error('Failed to update cart count:', error);
      });
  }
  
  // Initialize cart count on page load
  updateCartCount();
});




document.addEventListener('click', function(e) {
  const link = e.target.closest('.m-product-card__link');

  if (!link) return;

  const href = link.getAttribute('href');

  if (!href) return;

  window.location.href = href;
}, true);



// for mobile if font weight and size is 200 and 14px resp, then change it to 300 and 16px.
document.addEventListener('DOMContentLoaded', function () {
  function updateMobileFonts() {
    if (window.innerWidth > 767) return;

    const path = window.location.pathname;

    const isHomepage = path === '/' || path === '/en' || path === '/en/';
    const isProductPage = path.includes('/products/');

    document.querySelectorAll('body *').forEach(function (el) {
      const styles = window.getComputedStyle(el);
      const fontSize = styles.fontSize;
      const fontWeight = styles.fontWeight;

      // Homepage exception
      if (isHomepage && fontSize === '16px' && fontWeight === '200') {
        el.style.fontSize = '16px';
        el.style.fontWeight = '300';
        el.style.fontWeight = '300';
        el.style.lineHeight = '1.5em';
        return;
      }

      // Product page rich text exception
      if (
        isProductPage &&
        el.matches('.m-richtext__description, .m-richtext__description *') &&
        fontSize === '16px' &&
        fontWeight === '200'
      ) {
        el.style.fontSize = '16px';
        el.style.fontWeight = '300';
        el.style.lineHeight = '1.5em';
        return;
      }

      // Rest of the website logic
      if (!isHomepage && fontSize === '14px' && fontWeight === '200') {
        el.style.fontSize = '16px';
        el.style.fontWeight = '300';
        el.style.lineHeight = '1.5em';
      }
    });
  }

  updateMobileFonts();

  window.addEventListener('resize', updateMobileFonts);
});



// Agile Shorts Hero title CSS functionality
document.addEventListener('DOMContentLoaded', function () {
  var allowedPaths = [
    '/products/mens-agile-shorts-with-liner',
    '/products/mens-agile-shorts-without-liner',
    '/products/womens-agile-shorts-with-liner',
    '/products/womens-agile-shorts-without-liner'
  ];

  var currentPath = window.location.pathname.replace(/\/$/, '');

  if (allowedPaths.indexOf(currentPath) === -1) return;

  document.querySelectorAll('.product-page-hero-title-text').forEach(function (container) {
    var spans = container.querySelectorAll('.last-t');
    if (spans.length < 2) return;

    var lastTwo = Array.prototype.slice.call(spans, -2);

    var wrapper = document.createElement('p');
    wrapper.className = 'last-t-wrap';

    lastTwo[0].parentNode.insertBefore(wrapper, lastTwo[0]);

    lastTwo.forEach(function (span, i) {
      wrapper.appendChild(span);
      if (i === 0) {
        wrapper.appendChild(document.createTextNode(' ')); // re-add the space
      }
    });
  });
});


// quickview Size chart for Phaseout
document.addEventListener('click', function (e) {
  var el = e.target.closest('.size-chart-class');
  if (!el) return;

  var productId = el.dataset.productId;
  var productTitle = el.dataset.productTitle;

  alert('Product: ' + productTitle + ' (ID: ' + productId + ')');
});